module.exports = __webpack_public_path__ + "img/snow-small.ba677c1b.svg";